









import { Vue, Component, Prop } from "@/shared/vuepack";
@Component
export default class QsReportLink extends Vue {
  @Prop() linkText: string;
  @Prop() routeTo: any;
}
